export default __webpack_public_path__ + "static/S&FSharp-Semibold-21a05eef21391f118b16cb5346776232.woff";